import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-highlight-slider', observe: true })
export class HighlightSliderComponent {
	private swiper: Swiper;

	constructor(public element: HTMLElement) {
		this.swiper = new Swiper(this.element, {
			slidesPerView: 1.2,
			centeredSlides: true,
			spaceBetween: 30,			
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				bulletActiveClass: 'is-active'
			},
			breakpoints: {				
				768: {
					slidesPerView: 2,
					centeredSlides: false,
					
				},
				992: {
					slidesPerView: 3,
					centeredSlides: false,	
				}
			}				
		});
	}
}
